export interface PopupOrderState {
    order: PopupOrderItem[]
}

export type PopupType = "Eval" | "Webinar" | "Releases" | "RequestDirectBidding" | "RequestAllToAllBidding"

export enum PopupOrderStatus {
    Wait = "Wait",
    Shown = "Shown",
}

export interface PopupOrderItem {
    popup: PopupType
    status: PopupOrderStatus
}